(() => {
  const strings = JSON.parse(
    document.getElementById('theme-strings')?.textContent || '{}'
  );

  const errorMessage = strings.ringSizeRequired || "Select ring size";

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;

      console.log("check check check");
      if (!form.action.includes('/cart/add')) return;
      const sizeInput = document.querySelector('#ring-size-select');
    
      if (!sizeInput || !sizeInput.value || sizeInput.selectedIndex === 0) {
        e.preventDefault();
        e.stopImmediatePropagation();

        showToastMessage(errorMessage, 'error');
      }
    },
    true
  );
})();

let toastMessage = null;
let toastTimeout = null;

function showToastMessage(message = 'Added to cart', type = 'success') {
    if (!toastMessage) {
        toastMessage = document.createElement('div');
        toastMessage.classList.add('toast-message');
        document.body.appendChild(toastMessage);
    }

    toastMessage.textContent = message;

    toastMessage.classList.remove(
        'toast-success',
        'toast-error',
        'toast-info'
    );

    toastMessage.classList.add(`toast-${type}`);
    toastMessage.classList.add('visible');

    clearTimeout(toastTimeout);

    toastTimeout = setTimeout(() => {
        if (toastMessage) {
            toastMessage.classList.remove('visible');
        }
    }, 3000);
}